import React, { Component } from 'react';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';

import { setGuidePage } from '../../store/actions/SetGuidePage';

function mapStateToProps(state) {
   return {
    selectedPage: state.guide
  };
}

function mapDispatchToProps(dispatch) {
  return {
    setGuidePage: (page) => {
      dispatch(setGuidePage(page))
      browserHistory.push('/guide-to-gardening/' + page); 
    }
  }
}

class GuideLink extends Component {

  selectGuidePage(page) {
    this.props.setGuidePage(page);
    window.scrollTo(0, 0);
  }

  render() {
    const { slugTo, cta } = this.props;
    return (
      <Link onClick={this.selectGuidePage.bind(this, slugTo)}>
        {cta}
      </Link>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(GuideLink);


// WEBPACK FOOTER //
// ./src/components/GuideLink/GuideLink.js